import { useSyncExternalStore } from 'react';

export type StoragePersistence = 'unknown' | 'persistent' | 'memory';

let state: StoragePersistence = 'unknown';
const listeners = new Set<() => void>();

export function getStoragePersistence(): StoragePersistence {
  return state;
}

/** Set by the SQLite backend once it knows whether storage survives reloads. */
export function setStoragePersistence(next: StoragePersistence): void {
  if (state === next) {
    return;
  }
  state = next;
  for (const listener of listeners) {
    listener();
  }
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** React hook: reflects whether offline edits are stored durably. */
export function useStoragePersistence(): StoragePersistence {
  return useSyncExternalStore(subscribe, getStoragePersistence, () => 'unknown');
}
